import { gql, TypedDocumentNode } from '@apollo/client';

/* TIS GraphQL Queries */
export type ListUserAccessesByUserIdVars = {
  userId: string;
};

export type ListUserAccessesByUserId = {
  listUserAccessesByUserId?: {
    __typename: 'ModelUserAccessConnection';
    nextToken?: string | null;
    items?:
      | {
          id?: string;
          userId?: string;
          appId?: string;
          roleId?: string;
        }[]
      | null;
  } | null;
};

export const listUserAccessesByUserId = gql`
  query ListUserAccessesByUserId($userId: ID!) {
    listUserAccessesByUserId(userId: $userId) {
      items {
        id
        userId
        appId
      }
    }
  }
` as TypedDocumentNode<ListUserAccessesByUserId, ListUserAccessesByUserIdVars>;

/* WaffleMenu Config Types */
export type WaffleMenuLinkItem = {
  AppId?: string;
  Navigate: string;
  Icon: string;
  Name: string;
  AuthType?: string;
  PostEndpoint?: string;
};

export type WaffleMenuConfig = {
  LinkGroups: WaffleMenuLinkItem[][];
};

export type GetConfigVars = {
  name: string;
  type: string;
};

export type GetConfig = {
  getConfig?: {
    value?: string | null;
  } | null;
};

export const getConfig = gql`
  query GetConfig($name: ID!, $type: String!) {
    getConfig(name: $name, type: $type) {
      value
    }
  }
` as TypedDocumentNode<GetConfig, GetConfigVars>;
